var bighouse = bighouse || {};

bighouse.booking2 = (function() {

  function init(){



    //enabling / disabling [+] currently affects all - needs to be aware of the parents.

    $('.js-increment').each(function(e){

        var self = this;
        var maxValue = parseInt( $(self).attr('data-max'), 10);      
        var id = self.id;


        //if the attribute exists, pull in the price
        var pricePer =  $(self).attr('data-priceper');

        // For some browsers, `attr` is undefined; for others,
        // `attr` is false.  Check for both.
        if (typeof attr !== typeof undefined && attr !== false) {
          pricePer = parseFloat(pricePer);
        }


        $(self).find(".js-changeCount").on("click", function(e) {
          var $button = $(this);
          var theInput = $button.parent().find("input");
          var oldValue = theInput.val();
          var newVal = 0;

          var theSum = sumTotalCount(self); 
        
          if ($button.text() == "+") {
            
            var inputMax =  getInputMaxValue(  theInput );
            var excludeInputFromTotalSum = theInput.hasClass('FormCounter-input--dontinclude');
            var maxedInputMax = (parseFloat(oldValue) >= inputMax);

            if(  (excludeInputFromTotalSum && !maxedInputMax )  || (!excludeInputFromTotalSum && (theSum < maxValue ) && !maxedInputMax ) ){
              newVal = parseFloat(oldValue) + 1; 
            } else {
              newVal = oldValue;     
            }
                
            theInput.val(newVal);
    
          } else { 
            if (oldValue > 0)
              newVal = parseFloat(oldValue) - 1; 
            else
              newVal = 0; 
                  
              theInput.val(newVal);
          }

          //update the sum
          theSum = sumTotalCount(self);
          $(self).find(".js-total").text(theSum);

          //if price exists
          if(pricePer !== undefined){
            $(self).find(".js-price").text( theSum * pricePer  );
          }

          setButtonStates(newVal, theSum, maxValue, $button, self);
        });

    });
  }


  var incrementButton = ".FormCounter-button--increment";
  var decrementButton = ".FormCounter-button--decrement";
  
  function setButtonStates(newVal, theTotalSum, totalMaxValue, $button, incrementer){

    //if input value is 0 then disable
    //if input > 0 then enable
    if(newVal <= 0){
      disableButton( $button, decrementButton);
    } else {
      enableButton( $button, decrementButton);
    }

    //if max value has been reached, disabled all +
    if(theTotalSum >= totalMaxValue){
      //disable alllll that are included    
      $(incrementer).find('.FormCounter-input').not('.FormCounter-input--dontinclude').siblings(incrementButton).addClass('disabled');

      //TODO: check the dontincludes for their personal maxes
      $(incrementer).find('.FormCounter-input--dontinclude').each(function(){
        checkPersonalMax(this);
      });
    
    } else{
      //loop through all incrementers and check their personal max values
      $(incrementer).find('.FormCounter-input').each(function(){
        checkPersonalMax(this);
      });
    }
  }


  function checkPersonalMax(theInput){
    var thisValue = parseFloat( $(theInput).val() );
    var inputMax =  getInputMaxValue(theInput);

    if(inputMax > thisValue){
      //not reached yet
      //enabled +
      $(theInput).siblings(incrementButton).removeClass('disabled');
    } else {
      //personal max reached
      //disable +
      $(theInput).siblings(incrementButton).addClass('disabled');
    }
  }


  function sumTotalCount(currentGroup) {
    var totalCount = 0;
    $(currentGroup).find(".FormCounter-input").not('.FormCounter-input--dontinclude').each(function(index) {
      totalCount = totalCount + parseFloat($(this).val());
    });
    return totalCount;
  }



  function getInputMaxValue(theInput){
    var inputMax =  $(theInput).attr('max');

    if (inputMax === null || typeof inputMax === typeof undefined || inputMax === false) {
      inputMax = 9999999;
    }
    
    return inputMax;
  }


  function disableButton($button, buttontype){
    $button.parent().find(buttontype).addClass("disabled");
  }

  function enableButton($button, buttontype){
    $button.parent().find(buttontype).removeClass("disabled");
  }
  
  return {
    init: init
  };
})();
